// distributor-grid.component.ts

import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { Distributor } from '../objects/Distributor';
import { DistributorService } from '../Services/distributor.service';
import { Router, RouterLink } from '@angular/router';

 
@Component({
  selector: 'app-distributor-grid',
  templateUrl: './distributor-grid.component.html',
  styleUrls: ['./distributor-grid.component.css'],
})
export class DistributorGridComponent implements OnInit {
  
  items: any[] = [];
  pageOfItems?: Array<any>;
  sortProperty: string = 'id';
  sortOrder = 1;
  loading = false;
  distributors: Distributor[] = [];
  isLoadingResults: boolean | undefined;
   isMobile?: boolean;

  constructor(private distributorService: DistributorService,public router: Router) {}

  
  ngOnInit() {
    this.checkisMobile()
    this.loadDistributor();
  }

  loadDistributor() {
    this.distributorService.GetDistributor().subscribe((distributor) => {
      this.distributors = distributor;
      console.log(distributor);
      
    });
  }

  checkisMobile() { 
     
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
 
    if(width < 768)
    {this.isMobile = true;
    }
      else
    {this.isMobile = false;}
    
    
  }
    
  editDistributor(distributor: Distributor) {
    // Implement the edit functionality here
    // You can open a dialog or navigate to a separate edit page with the material's data
    
    this.router.navigate(['addeditdistributor', distributor.id]);
      // Implement the edit functionality here
      // You can open a dialog or navigate to a separate edit page with the material's data
   
    console.log('Editing material:', distributor);
  }

  
  deleteDistributor(distributor: Distributor) {
    this.distributorService.deleteDistributor(distributor)
        .subscribe(res => {
           let id = res['id'];
            
            this.isLoadingResults = false;
            this.router.navigate(['/distributor-grid' ]);
          }, (err) => {
            console.log(err);
            this.isLoadingResults = false;
          });
    this.router.navigate(['distributor-grid']);
      // Implement the edit functionality here
      // You can open a dialog or navigate to a separate edit page with the material's data
   
    console.log('Editing material:', distributor);
  }
  
  sortBy(property: string) {
     
    this.sortOrder = property === this.sortProperty ? (this.sortOrder * -1) : 1;
    this.sortProperty = property;
    this.items = [...this.distributors.sort((a: any, b: any) => {
        // sort comparison function
        let result = 0;
        if (a[property] < b[property]) {
            result = -1;
        }
        if (a[property] > b[property]) {
            result = 1;
        }
        return result * this.sortOrder;
    })];
}

sortIcon(property: string) {
    if (property === this.sortProperty) {
        return this.sortOrder === 1 ? '☝️' : '👇';
    }
    return '';
}
}

